import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=ef992cf8&scoped=true"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=ef992cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef992cf8",
  null
  
)

export default component.exports